import { useState } from 'react';
import SifreInput from '../components/SifreInput';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { sifreDegistirHatasi, SIFRE_EN_AZ_UZUNLUK } from '../helpers/sifreKurali';
import { UserService } from '../services/UserService';

interface Props {
    isShown: boolean
    onClose: () => void
    /** Sifre degisti: cagiran oturumu kapatir (sunucu tum oturumlari dusurdu). */
    onChanged: () => void
}

/** Kullanicinin kendi sifresini degistirdigi pencere (sag ust profil menusu). */
const SifreDegistirModal = ({ isShown, onClose, onChanged }: Props) => {
    const [mevcut, setMevcut] = useState('');
    const [yeni, setYeni] = useState('');
    const [tekrar, setTekrar] = useState('');
    const [kaydediliyor, setKaydediliyor] = useState(false);

    const temizle = () => {
        setMevcut('');
        setYeni('');
        setTekrar('');
    }

    const kapat = () => {
        temizle();
        onClose();
    }

    const kaydet = async () => {
        const hata = sifreDegistirHatasi(mevcut, yeni, tekrar);

        if (hata) {
            toast.error(hata);
            return;
        }

        try {
            setKaydediliyor(true);

            const response = await UserService.changeMyPassword(mevcut, yeni);

            if (!response.isSuccess) {
                toast.error(response.message);
                return;
            }

            toast.success(response.message);
            temizle();
            onChanged();
        } catch (error: any) {
            toast.error(error);
        } finally {
            setKaydediliyor(false);
        }
    }

    return (
        <Modal
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-500px'
            show={isShown}
            onHide={kapat}
            backdrop={'static'}
        >
            <div className='modal-header'>
                <h2 className='m-0'>Şifremi Değiştir</h2>
            </div>

            <div className='modal-body'>
                <div className='mb-5'>
                    <label htmlFor='sifreMevcut' className='form-label required'>Mevcut Şifre</label>
                    <SifreInput id='sifreMevcut' autoComplete='current-password' className='form-control form-control-solid' value={mevcut} onChange={(e) => setMevcut(e.target.value)} />
                </div>

                <div className='mb-5'>
                    <label htmlFor='sifreYeni' className='form-label required'>Yeni Şifre</label>
                    <SifreInput id='sifreYeni' autoComplete='new-password' placeholder={`En az ${SIFRE_EN_AZ_UZUNLUK} karakter`} className='form-control form-control-solid' value={yeni} onChange={(e) => setYeni(e.target.value)} />
                </div>

                <div>
                    <label htmlFor='sifreTekrar' className='form-label required'>Yeni Şifre (Tekrar)</label>
                    <SifreInput id='sifreTekrar' autoComplete='new-password' className='form-control form-control-solid' value={tekrar} onChange={(e) => setTekrar(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') kaydet(); }} />
                </div>

                <div className='text-muted fs-7 mt-4'>Şifreniz değişince açık olan tüm oturumlarınız kapanır; yeni şifrenizle tekrar giriş yaparsınız.</div>
            </div>

            <div className='modal-footer'>
                <button type='button' className='btn btn-light btn-sm' onClick={kapat} disabled={kaydediliyor}>Vazgeç</button>
                <button type='button' className='btn btn-primary btn-sm' onClick={kaydet} disabled={kaydediliyor}>{kaydediliyor ? 'Kaydediliyor…' : 'Şifreyi Değiştir'}</button>
            </div>
        </Modal>
    )
}

export default SifreDegistirModal;
